import $ from 'jquery';

const triggerModal = () => {
    if (document.querySelector('.modal-trigger')) {
        document.addEventListener('click', ev => {

            if (!ev.target.parentElement.classList.contains('modal-trigger')) return;
            $('#ume-apply-modal-id').modal('show');
        })
    }
}
export default triggerModal;